import { faker } from '@faker-js/faker'

import { RewardRule, RewardType } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getRewardRule = asBuilder((): RewardRule => {
  const minAmountInclusive = faker.number.int()
  return {
    type: faker.helpers.enumValue(RewardType),
    rewardDetails: faker.helpers.multiple(() => ({
      description: faker.string.uuid(),
      priceRange: {
        minAmountInclusive: faker.number.int(),
        maxAmountExclusive: faker.number.int({ min: minAmountInclusive + 100 }),
      },
      point: {
        paybackPercentage: faker.number.int({ min: 1, max: 100 }),
        amount: faker.number.int(),
      },
    })),
  }
})
